export default {"src":"/login-app/[GIT_HASH]/_next/static/media/source_asset.7c8c03a3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};